<template>
<!-- :breakpoints="{
        320: {
            slidesPerView: 1,
            spaceBetween: 20,
            slidesPerGroup: 1
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 20,
            slidesPerGroup: 2
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 20,
            slidesPerGroup: 3
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 30,
            slidesPerGroup: 4
        },
        }" -->
  <div class="container area-slides" v-if="data.length > 0">
    <swiper ref="slideExam"
      :slides-per-view="view"
      :slides-per-group="view"
      :breakpoints="breakpoints"
      :observeParents="true"
      :observer="true"
      :space-between="30"
      :loop="true"
      :pagination="true"
      :navigation="false"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <swiper-slide
        v-for="(item,index) in data"
        :key="item.lc_id"
      >
        <b-card
            title=""
            :img-src="item.img_course_path ? item.img_course_path : 'https://picsum.photos/600/300/?image=25'"
            img-alt="Image"
            img-top
            tag="article"
            style=""
            class="mb-2"
        >
            <a target="_blank" class="stretched-link" :href="convertTitleToSlug(item.vi_title, item.lc_id)">
                <p class="t-teacher fsize-14 color-1 d-flex align-items-center mb-1">
                    <img class="mr-1" src="../../assets/images/Exam/try-exam-23.png" alt="">
                    {{ item.firstname }}
                </p>
            </a>
            <p class="fsize-16 color-2 mb-1 line-2">
                {{  locale == 'vi' ? item.vi_title : item.title }}
            </p>
            <p class="fsize-14 color-1 d-flex align-items-center mb-1">
                <img class="mr-1" src="../../assets/images/Exam/try-exam-24.png" alt="">
                <b>{{ item.total_student }}</b> &nbsp; {{ $t("tryExam.student_register") }}
            </p>
            <p class="fsize-12">
                <del class="color-3">{{ formatNumber(item.root_price) }} vnđ</del> <span class="color-4">({{ item.discount }}%)</span>
            </p>
            <p class="fsize-20 color-2 fw-500">
                {{  formatNumber(item.price) }} VND
            </p>
            <hr class="my-1">
            <b-row class="d-flex justify-content-between">
                <b-col col="" class="d-flex align-items-center fsize-14 color-1 p-0">
                    <img class="mr-1" src="../../assets/images/Exam/try-exam-25.png" alt="">
                    {{ item.lecturecnt }} {{ $t("tryExam.lecture") }}
                </b-col>
                <b-col col="" class="d-flex align-items-center fsize-14 color-1 p-0 justify-content-end">
                    <img class="mr-1" src="../../assets/images/Exam/try-exam-26.png" alt="">
                    {{ item.courseperiod }} {{ $t("tryExam.day") }}
                </b-col>
            </b-row>

        </b-card>
      </swiper-slide>
    </swiper>
    <div @click="prev" class="swiper-button-prev" :class="{'swiper-button-disabled' : disablePrev}"></div>
    <div @click="next" class="swiper-button-next" :class="{'swiper-button-disabled' : disableNext}"></div>

  </div>

</template>

<script>
import { mapGetters } from "vuex";
import { Navigation, Pagination } from "swiper";

import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";

// Import Swiper styles
import "swiper/swiper-bundle.css";

SwiperCore.use([Navigation, Pagination]);

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props:{
    view: Number,
    isType: {
        type: Boolean,
        default: true
    },
    breakpoints:{
        type: Object,
        default: () =>{}
    },
    data: {
        type: Array,
        default(){
            return [
                {
                    "id": 2128,
                    "lc_id": 111,
                    "img_course_id": 108,
                    "title": "[-30%] 한국어 초급 2 (100강)",
                    "vi_title": "[-30%] Tiếng Hàn Sơ Cấp 2 (100 Bài Giảng)",
                    "en_title": "[-30%] Tiếng Hàn Sơ Cấp 2 (100 Bài Giảng)",
                    "firstname": "Ninh Thị Thúy",
                    "total_student": "88",
                    "user_like": "0",
                    "root_price": "1200000",
                    "price": "840000",
                    "discount": "30",
                    "lecturecnt": "100",
                    "courseperiod": "180",
                    "tags": "5,6,7,6,6",
                    "created_at": "2023-07-26 09:27:02",
                    "updated_at": "2023-07-26 09:27:02",
                    "img_course_path": "https://video.masterkorean.vn/theme/oklassedu/pix/images/default_course.png"
                },
                {
                    "id": 2125,
                    "lc_id": 142,
                    "img_course_id": 198,
                    "title": "COMBO: 초급+중급 (무료체험 이벤트)",
                    "vi_title": "[Học thử miễn phí] COMBO: Tiếng Hàn Sơ cấp & Trung cấp",
                    "en_title": "COMBO: Beginner  & Intermediate Korean (Try for FREE)",
                    "firstname": "Ninh Thị Thúy, Kim Mi Sook",
                    "total_student": "661",
                    "user_like": "0",
                    "root_price": "4800000",
                    "price": "0",
                    "discount": "0",
                    "lecturecnt": "18",
                    "courseperiod": "30",
                    "tags": "5,6,7,6",
                    "created_at": "2023-07-26 09:27:02",
                    "updated_at": "2023-07-26 09:27:02",
                    "img_course_path": "https://video.masterkorean.vn/theme/oklassedu/pix/images/default_course.png"
                },
                {
                    "id": 2124,
                    "lc_id": 249,
                    "img_course_id": 633,
                    "title": "Giải đề TOPIK II - cô Phạm Linh UEF - 28 video",
                    "vi_title": "Giải đề TOPIK II - cô Phạm Linh UEF - 28 video",
                    "en_title": "Giải đề TOPIK II - cô Phạm Linh UEF - 28 video",
                    "firstname": "Phạm Thị Thùy Linh",
                    "total_student": "1",
                    "user_like": "0",
                    "root_price": "1000000",
                    "price": "1000000",
                    "discount": "0",
                    "lecturecnt": "28",
                    "courseperiod": "90",
                    "tags": "41,2,6",
                    "created_at": "2023-07-26 09:27:02",
                    "updated_at": "2023-07-26 09:27:02",
                    "img_course_path": "https://video.masterkorean.vn/theme/oklassedu/pix/images/default_course.png"
                },
                {
                    "id": 2127,
                    "lc_id": 126,
                    "img_course_id": 176,
                    "title": "COMBO 한국어 초급1 (122 Video) + 교재",
                    "vi_title": "COMBO Tiếng Hàn Sơ cấp 1 (122 Video) + Giáo trình",
                    "en_title": "COMBO For Beginner 1 (122 Videos) + Textbook",
                    "firstname": "Ninh Thị Thúy",
                    "total_student": "165",
                    "user_like": "0",
                    "root_price": "999000",
                    "price": "999000",
                    "discount": "0",
                    "lecturecnt": "122",
                    "courseperiod": "210",
                    "tags": "2",
                    "created_at": "2023-07-26 09:27:02",
                    "updated_at": "2023-07-26 09:27:02",
                    "img_course_path": "https://video.masterkorean.vn/theme/oklassedu/pix/images/default_course.png"
                },
                {
                    "id": 2126,
                    "lc_id": 129,
                    "img_course_id": 172,
                    "title": "[-30%] 기초 한국어회화 (MasterTalk) - 22강",
                    "vi_title": "[-30%] MasterTalk: Nhập Môn Tiếng Hàn Giao Tiếp (22 Video)",
                    "en_title": "[-30%] Basic Korean Conversation (MasterTalk) - 22 Videos",
                    "firstname": "Ninh Thị Thúy",
                    "total_student": "28",
                    "user_like": "0",
                    "root_price": "550000",
                    "price": "385000",
                    "discount": "30",
                    "lecturecnt": "22",
                    "courseperiod": "90",
                    "tags": "6",
                    "created_at": "2023-07-26 09:27:02",
                    "updated_at": "2023-07-26 09:27:02",
                    "img_course_path": "https://video.masterkorean.vn/theme/oklassedu/pix/images/default_course.png"
                }
            ];
        }
    },
  },
  data() {
    return {
      swiper: null,
      disableNext: false,
      disablePrev: false,
    };
  },
  created(){
   // console.log(this.data);
   // console.log((2500).toLocaleString()); /* $2,500.00 */
  },
  computed: {
     ...mapGetters({

            locale: "lang/locale"
        }),
  },
  updated() {



  },
  methods: {
    getImageUrl(imageId) {
      return `https://picsum.photos/600/400/?image=${imageId}`;
    },
    onSwiper(swiper) {

      this.swiper = swiper;
    },
    onSlideChange() {
     // this.swiper.isEnd === true ? this.disableNext = true : this.disableNext = false;
     // this.swiper.isBeginning === true ? this.disablePrev = true : this.disablePrev = false;
    },
    next(){
        this.swiper.slideNext();
       // this.swiper.isEnd === true ? this.disableNext = true : this.disableNext = false;
      //  this.disablePrev = false;
    },
    prev(){

        this.swiper.slidePrev();
       // this.disableNext = false;
       // this.swiper.isBeginning === true ? this.disablePrev = true : this.disablePrev = false;
    },

    formatNumber(n){
        var x = Number(n)
        return (x).toLocaleString();
    },
    toSlug(str) {
        // Chuyển hết sang chữ thường
        str = str.toLowerCase();

        // xóa dấu
        str = str
            .normalize('NFD') // chuyển chuỗi sang unicode tổ hợp
            .replace(/[\u0300-\u036f]/g, ''); // xóa các ký tự dấu sau khi tách tổ hợp

        // Thay ký tự đĐ
        str = str.replace(/[đĐ]/g, 'd');

        // Xóa ký tự đặc biệt
        str = str.replace(/([^0-9a-z-\s])/g, '');

        // Xóa khoảng trắng thay bằng ký tự -
        str = str.replace(/(\s+)/g, '-');

        // Xóa ký tự - liên tiếp
        str = str.replace(/-+/g, '-');

        // xóa phần dư - ở đầu & cuối
        str = str.replace(/^-+|-+$/g, '');

        // return
        return str;
    },

    convertTitleToSlug(title, id){
        //let t = title.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, "-");

        return 'https://www.masterkorean.vn/course/' + this.toSlug(title) + '?courseid='+ id;
    }

  },
};
</script>

<style scoped>
.area-slides{
    border-radius: 50px;
    background: linear-gradient(180deg, #F1F4FF 0%, rgba(174, 185, 208, 0.00) 100%);
    padding: 30px 40px 0;
    position: relative;
}
.container {
  width: 100%;
  max-width: 100%;
  height: auto;
  overflow: hidden;
}

.swiper-container {
  width: 100%;
  height: 100%;
  overflow: inherit;
  padding-bottom: 30px;
}


.color-1{
    color: #75787B;
}
.color-2{
    color: #485CC7;
}
.color-3{
    color: #97999B;
}
.color-4{
    color: #F5222D;
}
.card-body{
    padding: 7px 12px 13px 12px;
}

.line-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
/* .card-img-top {
    height: auto;
    -o-object-fit: contain;
    object-fit: contain;
} */

</style>

<style>
.swiper-pagination-bullet{
    background: #ADC6FF;
    opacity: 1;
}
.swiper-pagination-bullet-active{
    width: 24px;
    border-radius: 4px;
    background: #485CC7;
}
.swiper-button-prev:after, .swiper-button-next:after{
    color: #808EB1;
    font-size: 27px;
    font-weight: bold;
    content: '';
    background: url('../../assets/images/Exam/next.png') center center no-repeat;
    width: 40px;
    height: 40px;
}
.swiper-button-prev:after{
    background: url('../../assets/images/Exam/prev.png') center center no-repeat;
}

</style>
